import {faBell} from '@fortawesome/pro-regular-svg-icons';
import useTranslation from 'next-translate/useTranslation';

import AppBarIconButton from '../AppBarIconButton';

type NotificationsButtonProps = Omit<
  React.ComponentProps<typeof AppBarIconButton>,
  'aria-label' | 'icon' | 'title'
> & {
  unreadNotificationCount?: number;
};

const NotificationsButton: React.FC<NotificationsButtonProps> = ({
  unreadNotificationCount,
  ...props
}) => {
  const {t} = useTranslation('app-bar');

  return (
    <AppBarIconButton
      aria-label={t('notifications.label')}
      icon={faBell}
      title={t('notifications.unreadTitle', {unreadNotificationCount})}
      variant="secondary"
      {...props}
    />
  );
};

export default NotificationsButton;
